import { Typography } from '@material-ui/core';
import { showErrorOnChange, useFieldForErrors } from 'mui-rff';
import React from 'react';

import { useStyles } from './styles';

const LabelField = ({ name, children }: any) => {
  const field = useFieldForErrors(name);
  const styles = useStyles({
    isError: showErrorOnChange({
      meta: field.meta,
    }),
  });

  return (
    <Typography className={styles.text} variant="subtitle2" gutterBottom>
      {children}
    </Typography>
  );
};

LabelField.displayName = 'LabelField';

export default LabelField;
